"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberUtils = void 0;
var NumberUtils = (function () {
    function NumberUtils() {
    }
    NumberUtils.areClose = function (num1, num2) {
        var delta = num1 - num2;
        return delta == 0 || Math.abs(delta) < this.epsilon;
    };
    NumberUtils.lessThan = function (num1, num2) {
        return (num1 < num2) && !this.areClose(num1, num2);
    };
    NumberUtils.greaterThan = function (num1, num2) {
        return (num1 > num2) && !this.areClose(num1, num2);
    };
    NumberUtils.epsilon = 0.00000153;
    return NumberUtils;
}());
exports.NumberUtils = NumberUtils;
